import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class AnalisesProjetoService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getFiltrosContratos(nome?: string) {
    const params = new HttpParams().set('nome', nome || '');
    return this.http.get(this.baseUrl + `/v1/analises-projeto/filtros/contratos`, { params });
  }

  getFiltrosObras(idContrato: string) {
    const params = new HttpParams().set('idContrato', idContrato);
    return this.http.get(this.baseUrl + `/v1/analises-projeto/filtros/obras`, { params });
  }

  getFiltrosResponsaveis(nome?: string) {
    const params = new HttpParams().set('nome', nome || '');
    return this.http.get(this.baseUrl + `/v1/analises-projeto/filtros/responsaveis`, { params });
  }

  getFiltrosStatus() {
    return this.http.get<any[]>(this.baseUrl + `/v1/analises-projeto/filtros/status`);
  }

  private buildListaParams(
    pageSize: number,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    buscaRapida: string | null,
    idContrato: string | null,
    idObra: string | null,
    idResponsavel: string | null,
    statusFilter: any,
    prazoInicio: string | null,
    prazoFim: string | null,
    foraDoPrazo: boolean | null,
  ): HttpParams {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('buscaRapida', buscaRapida || '')
      .set('idContrato', idContrato || '')
      .set('idObra', idObra || '')
      .set('idResponsavel', idResponsavel || '')
      .set('prazoInicio', prazoInicio || '')
      .set('prazoFim', prazoFim || '')
      .set('foraDoPrazo', foraDoPrazo === true ? 'true' : foraDoPrazo === false ? 'false' : '');

    if (statusFilter && statusFilter !== 'Todos') {
      statusFilter.forEach((status: any) => params = params.append('status', status.valor || status.descricao));
    }

    return params;
  }

  getListaFuncional(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    buscaRapida: string | null,
    idContrato: string | null,
    idObra: string | null,
    idResponsavel: string | null,
    statusFilter: any,
    prazoInicio: string | null = null,
    prazoFim: string | null = null,
    foraDoPrazo: boolean | null = null,
  ) {
    const params = this.buildListaParams(pageSize, pageIndex, sortDirection, sortProperty, buscaRapida, idContrato, idObra, idResponsavel, statusFilter, prazoInicio, prazoFim, foraDoPrazo);
    return this.http.get(this.baseUrl + `/v1/analises-projeto/funcional`, { params });
  }

  getListaExecutivo(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    buscaRapida: string | null,
    idContrato: string | null,
    idObra: string | null,
    idResponsavel: string | null,
    statusFilter: any,
    prazoInicio: string | null = null,
    prazoFim: string | null = null,
    foraDoPrazo: boolean | null = null,
  ) {
    const params = this.buildListaParams(pageSize, pageIndex, sortDirection, sortProperty, buscaRapida, idContrato, idObra, idResponsavel, statusFilter, prazoInicio, prazoFim, foraDoPrazo);
    return this.http.get(this.baseUrl + `/v1/analises-projeto/executivo`, { params });
  }

  getListaExecutivoDisciplinas(
    idProjetoServicoAmpliacao: string,
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
  ) {
    const params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '');
    return this.http.get(this.baseUrl + `/v1/analises-projeto/executivo/${idProjetoServicoAmpliacao}/disciplinas`, { params });
  }
}
